export default {
  namespaced: true,

  state: {
    isOpen: false,
    context: "",
    comment: null,
    hash: "",
    isNew: false,
    isLandingPage: false,
    deceasedName: "",
    possessiveName: "",
    memorialFund: null,
    // Tracks the id of the most recently auto-opened "new" comment so that
    // SingleComment.setIsNew() can skip re-opening the share modal when the
    // user later switches to masonry view.
    openedNewCommentId: null,
  },

  mutations: {
    setState(state, payload = {}) {
      Object.assign(state, payload);
    },

    setIsOpen(state, isOpen = false) {
      state.isOpen = isOpen;
    },

    setContext(state, context = "") {
      state.context = context;
    },

    setIsNew(state, isNew = false) {
      state.isNew = isNew;
    },
  },

  actions: {
    open({ commit, state }, payload = {}) {
      const isNew = !!payload.isNew;
      const commentId = payload.comment ? payload.comment.id : null;

      commit("setState", {
        isOpen: true,
        context: payload.context || "",
        comment: payload.comment || null,
        hash: payload.hash || "",
        isNew,
        isLandingPage: !!payload.isLandingPage,
        deceasedName: payload.deceasedName || "",
        possessiveName: payload.possessiveName || "",
        memorialFund: payload.memorialFund || null,
        openedNewCommentId: isNew ? commentId : state.openedNewCommentId,
      });
    },

    close({ commit }) {
      commit("setIsOpen", false);
    },

    changeContext({ commit }, context = "") {
      commit("setContext", context);
    },

    resetIsNew({ commit }) {
      commit("setIsNew", false);
    },
  },
};
